import StaffAvatar from './StaffAvatar';
import { PersonOutline } from '@mui/icons-material';
import { AvatarGroup } from '@mui/material';
import { memo } from 'react';

const StaffAvatarGroup = ({ members, addButton, ...rest }) => {
  if (members.length === 0 && addButton) {
    return (
      <div className="relative p-4 text-gray-500 border-2 border-gray-500 border-dashed rounded-full">
        <PersonOutline />
        <div className="absolute w-12 h-12 leading-none text-center text-white bg-gray-500 rounded-full -bottom-2 -right-2 text-11">
          +
        </div>
      </div>
    );
  }

  if (members.length === 0) return null;

  return (
    <AvatarGroup max={3} {...rest}>
      {members.map((member, index) => {
        return <StaffAvatar key={index} staff={member} />;
      })}
    </AvatarGroup>
  );
};

export default memo(StaffAvatarGroup);
